import React, { useState } from "react";
import styles from "./AimcModal.module.css";
import { readproPackagePurchaseViaPGI } from "../../../Services/pgi";
import { deviceCheck } from "../../../Values/utils";

const AimcModal = ({user,dispatcher}: any) => {
  const [selectedAmount, setSelectedAmount] = useState("15000");
  const [showModal, setShowModal] = useState(true);

  const handleClose = () => setShowModal(false);
  const handleKnowMore = () => alert("Redirecting to more details...");
  const handleActivateTrial = () => {
    readproPackagePurchaseViaPGI(user.user_super_oid, "332049", dispatcher, deviceCheck());
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className={styles.aimc}>
      <div className={styles.aimc__modal}>
        {/* LEFT SIDE */}
        <div className={styles.aimc__lt}>
          <div className={styles.aimc__lt__title}></div>
          <div className={styles.aimc__lt__cong}>Congratulations!</div>
          <div className={styles.aimc__lt__unlock}>
            You've unlocked an exclusive trial
          </div>

          <div className={styles.aimc__lt__credit}>
            <div className={styles.aimc__lt__credit__1}>Instant credit of</div>
            <div className={styles.aimc__lt__credit__2}>
              <span className={styles.rupee}>&#8377;</span> 15,000
            </div>
            <div className={styles.aimc__lt__credit__3}>in your wallet</div>
          </div>

          <div className={styles.aimc__lt__benef}>Benefits of AI MagicConnect</div>

          <ul className={styles.aimc__lt__ul}>
            <li
              className={`${styles.aimc__lt__li} ${styles.aimc__lt__li__1}`}
            >
              Define the Leads You Want
            </li>
            <li
              className={`${styles.aimc__lt__li} ${styles.aimc__lt__li__2}`}
            >
              Live Call with Buyers
            </li>
            <li
              className={`${styles.aimc__lt__li} ${styles.aimc__lt__li__3}`}
            >
              Keep Your Leads Exclusive
            </li>
          </ul>

          {/* <button className={styles.aimc__lt__know} onClick={handleKnowMore}>
            Know More
          </button> */}
        </div>

        {/* RIGHT SIDE */}
        <div className={styles.aimc__rt}>
          <div className={styles.aimc__rt__close} onClick={handleClose}></div>

          <div className={styles.aimc__rt__title}>
            <div className={styles.aimc__rt__title__sb}>To claim your trial,</div>
            please set up automatic payment starting from next month
          </div>

          <div className={styles.aimc__rt__txt1}>Choose a monthly amount</div>
          <div className={styles.aimc__rt__txt2}>
            You can cancel anytime from your dashboard.
          </div>

          <div className={styles.aimc__rt__options}>
            {["15000"].map((amt) => (
              <React.Fragment key={amt}>
                <input
                  type="radio"
                  id={`amt-${amt}`}
                  name="monthlyAmt"
                  className={styles.aimc__rt__ip}
                  checked={selectedAmount === amt}
                  onChange={() => setSelectedAmount(amt)}
                />
                <label
                  htmlFor={`amt-${amt}`}
                  className={`${styles.aimc__rt__label} ${
                    amt === "15000" ? styles.aimc__rt__label__recom : ""
                  }`}
                >
                  <span>
                    <span className={styles.rupee}>&#8377;</span>
                    {amt}
                  </span>
                  {amt === "20000" && (
                    <span className={styles.aimc__rt__recom}>Recommended</span>
                  )}
                </label>
              </React.Fragment>
            ))}
          </div>

          <div className={styles.aimc__rt__cta} onClick={handleActivateTrial}>
            Pay <span className={styles.rupee}>&#8377;</span>1 to Activate Trial
          </div>

          <div className={styles.aimc__rt__note}>
            You'll be notified when the balance is below{" "}
            <span className={styles.rupee}>&#8377;</span>1,500.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AimcModal;